import { useState, useEffect, useContext, useRef } from 'react'
import Select from 'react-select';
import ContextStates from '../context/ContextStates';
import ReactToPrint from 'react-to-print';
import { FaPrint } from 'react-icons/fa'
import Filtros from "./Filtros";
import axios from 'axios';
import { Url } from './Url';
import { Link } from 'react-router-dom';


const ListadoProductosPedidos = () => {
    const [productos, setProductos] = useState([])
    const [productosEditados, setProductosEditados] = useState({})
    const [loading, setLoading] = useState(false)

    const { idUsuario, modify, setModify, zona, fechaInicio, fechaFin, usuario } = useContext(ContextStates)
    const componentRef = useRef();



    useEffect(() => {
        const getProductosPedidos = async () => {
            console.log('Usuario:', usuario)
            console.log('Zona:', zona)
            console.log('Fecha inicio:', fechaInicio)
            console.log('Fecha fin:', fechaFin)
            let z = 0;
            if (zona.id)
                z = zona.id;
            let u = 0;
            if (typeof usuario.id !== 'undefined')
                u = usuario.id;
            console.log('Usuario:', usuario)
            const formData = new FormData()
            formData.append('zona', z);
            formData.append("fechaInicio", fechaInicio)
            formData.append("fechaFin", fechaFin)
            formData.append("usuario", u)
            try {
                const results = await axios({
                    url: Url + 'api/getProductosPedidos.php',
                    method: 'POST',
                    data: formData,
                })
                console.log('Respuesta completa:', results)
                // Siempre actualizar productos, incluso si es un array vacío
                // Esto limpia los productos anteriores cuando no hay pedidos
                const productosRecibidos = results.data.results || []
                console.log('Productos recibidos:', productosRecibidos)
                // Log del primer producto para ver su estructura
                if (productosRecibidos.length > 0) {
                    console.log('Estructura del primer producto:', productosRecibidos[0])
                }
                setProductos(productosRecibidos)
            } catch (e) {
                console.log(e)
            }
        }
        getProductosPedidos()
    }, [modify, zona, fechaInicio, fechaFin, usuario])

    const handleCantidadChange = (index, nuevaCantidad) => {
        setProductosEditados(prev => ({
            ...prev,
            [index]: nuevaCantidad
        }))
    }

    const resetCantidades = () => {
        setProductosEditados({})
    }

    const limpiarTodo = () => {
        const todasEnCero = {}
        productos.forEach((_, index) => {
            todasEnCero[index] = 0
        })
        setProductosEditados(todasEnCero)
    }

    const generarReparto = async () => {
        // Preparar productos con cantidades editadas
        const productosParaReparto = productos
            .map((item, index) => {
                const cantidad = productosEditados[index] !== undefined
                    ? productosEditados[index]
                    : item.cantidad

                // Extraer el ID del producto - puede venir con diferentes nombres
                const idproducto = item.id || item.idproducto || item.idProducto || item.producto_id || 0

                return {
                    ...item,
                    idproducto: idproducto,  // Asegurar que siempre exista este campo
                    id: idproducto,           // También mantener 'id' para compatibilidad
                    cantidad: parseFloat(cantidad)
                }
            })
            .filter(item => item.cantidad > 0)

        if (productosParaReparto.length === 0) {
            alert('No hay productos con cantidad para generar el reparto')
            return
        }

        console.log('=== DATOS A ENVIAR AL BACKEND ===')
        console.log('Productos para reparto:', productosParaReparto)
        console.log('Primer producto:', productosParaReparto[0])
        console.log('ID Usuario:', idUsuario)

        setLoading(true)

        const formData = new FormData()
        formData.append('venta', JSON.stringify(productosParaReparto))
        formData.append('idusuario', idUsuario)
        //formData.append('total', total)

        try {
            const response = await axios({
                url: Url + 'api/finGenReparto.php',
                method: 'POST',
                data: formData,
            })

            console.log('Respuesta del servidor:', response)

            if (response.data) {
                alert('Reparto generado exitosamente')
                // Limpiar cantidades editadas
                setProductosEditados({})
                // Recargar datos
                setModify(prev => prev + 1)
            }
        } catch (e) {
            console.error('Error al generar reparto:', e)
            alert('Error al generar el reparto. Por favor, intente nuevamente.')
        } finally {
            setLoading(false)
        }
    }

    const calcularTotal = () => {
        return productos.reduce((acc, item, index) => {
            const cantidad = productosEditados[index] !== undefined
                ? productosEditados[index]
                : item.cantidad
            const precio = item.precio || 0
            return acc + (parseFloat(precio) * parseFloat(cantidad || 0))
        }, 0)
    }

    const hayProductosConCantidad = () => {
        return productos.some((item, index) => {
            const cantidad = productosEditados[index] !== undefined
                ? productosEditados[index]
                : item.cantidad
            return parseFloat(cantidad || 0) > 0
        })
    }



    return (
        <div className='w-full' ref={componentRef}>
            <h2 className='text-center text-3xl mt-5 mb-3'>Listado de Productos para repartos</h2>
            <div className='bg-blue-100 rounded-md p-3 mb-5 print:mb-0 print:hidden'>
                <Filtros />
            </div>
            <div className='w-10/12 mx-auto mb-5 print:block hidden'>
                <p><span className='font-bold'>Usuario:</span> {usuario.nombre}</p>
                <p><span className='font-bold'>Zona:</span> {zona.nombre}</p>
                <p><span className='font-bold'>Fecha inicio:</span> {fechaInicio}</p>
                <p><span className='font-bold'>Fecha fin:</span> {fechaFin}</p>
            </div>
            <div className="transition-all w-full mt-3 print:mt-0">
                <div className="w-full rounded-lg p-5 print:p-0 justify-center">
                </div>
                <div className="w-10/12 mx-auto py-5 print:py-0 px-2">
                    {typeof productos !== 'undefined' && productos.length > 0 && (
                        <div className='w-full'>
                            <div className='w-full mb-4 p-4 bg-blue-50 rounded-lg border border-blue-200 print:hidden'>
                                <div className='flex justify-end items-center'>
                                    <div className='flex gap-2'>
                                        <button
                                            className='px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-all'
                                            onClick={resetCantidades}
                                            disabled={Object.keys(productosEditados).length === 0}
                                        >
                                            Reset
                                        </button>
                                        <button
                                            className='px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600 transition-all'
                                            onClick={limpiarTodo}
                                        >
                                            Limpiar Todo
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <table className='w-full mx-auto'>
                                <thead>
                                    <tr className='p-1 bg-blue-400 text-white text-center'>
                                        <th>Producto</th>
                                        <th>Cantidad Original</th>
                                        <th className='print:hidden'>Cantidad Editada</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        productos.map((item, index) => {
                                            const cantidadEditada = productosEditados[index] !== undefined
                                                ? productosEditados[index]
                                                : item.cantidad
                                            const fueEditado = productosEditados[index] !== undefined
                                            const precio = item.precio || 0
                                            const subtotal = parseFloat(precio) * parseFloat(cantidadEditada || 0)

                                            return (
                                                <tr
                                                    key={index}
                                                    className={`hover:cursor-pointer border-b border-gray-200 text-center print:text-left print:pl-3 ${fueEditado
                                                        ? 'bg-green-100 hover:bg-green-200'
                                                        : item.saldo && item.saldo > 0 && item.saldo === item.total
                                                            ? 'bg-red-300'
                                                            : item.saldo > 0 && item.saldo < item.total
                                                                ? 'bg-orange-300'
                                                                : index % 2 === 0
                                                                    ? 'bg-white hover:bg-slate-200'
                                                                    : 'bg-slate-100 hover:bg-slate-200'
                                                        }`}
                                                >
                                                    <td className='px-3 py-2 print:py-0'>{item.producto}</td>
                                                    <td className='px-3 py-2 print:py-0'>{item.cantidad}</td>
                                                    <td className='px-3 py-2 print:hidden'>
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            className={`w-24 p-2 border rounded text-center ${fueEditado ? 'border-green-500 border-2' : 'border-gray-300'
                                                                }`}
                                                            value={cantidadEditada}
                                                            onChange={(e) => handleCantidadChange(index, e.target.value)}
                                                        />
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
            <div className="w-10/12 mx-auto py-5">
                <div className='flex gap-3 flex-wrap'>
                    <ReactToPrint
                        trigger={() =>
                            <p
                                className="print:hidden hover:cursor-pointer w-full sm:w-auto flex shadow-md p-3 bg-indigo-500 text-white hover:bg-indigo-400 transition-all uppercase font-bold rounded-lg"
                            >
                                <FaPrint className='mx-auto mt-1' />
                                <span className='mx-auto text-center ml-2'>
                                    Imprimir Listado
                                </span>
                            </p>}
                        content={() => componentRef.current}
                    />
                    <button
                        className={`print:hidden hover:cursor-pointer w-full sm:w-auto flex shadow-md p-3 uppercase font-bold rounded-lg transition-all ${loading
                            ? 'bg-gray-400 cursor-wait'
                            : hayProductosConCantidad()
                                ? 'bg-green-500 text-white hover:bg-green-400'
                                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            }`}
                        onClick={generarReparto}
                        disabled={!hayProductosConCantidad() || loading}
                    >
                        <span className='mx-auto text-center'>
                            {loading ? 'Generando...' : 'Generar Reparto'}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ListadoProductosPedidos